import PropTypes from 'prop-types';
import React, { useState } from 'react';
import circleExitRed from '../img/iconbutton-close-24.svg';
import circleExitWhite from '../img/iconbutton-close-24.svg';

import SecondaryButton from "./SecondaryButton";
import IconButton from './IconButton';

function CloseButton({
  onClick,
  label,
  // mode,
  size,
  tabable,
  name,
  id,
  onlyIcon
}: {
  onClick: VoidFunction,
  label?: string,
  mode?: 'regular'|'light',
  size?: string|undefined,
  tabable?: boolean|undefined,
  name?: string|undefined
  id?: string|undefined,
  onlyIcon? : boolean|undefined
}) {
  const [isMouseOver, setIsMouseOver] = useState(false);
  // if(mode === 'light') {
  //   return (
  //     <SecondaryButton size={size || 'regular'} onClick={onClick}>
  //       <div className="ifms-close-btn-icon">&nbsp;<FontAwesomeIcon icon={faTimes} />&nbsp;</div>&nbsp;{label || `Close`}
  //     </SecondaryButton>
  //   );
  // }

  if (onlyIcon) {
    return (
      <IconButton style={{alignItems: 'center',justifyContent: 'center'}} notsetbackcolorwhenfocus="b" id={id} onMouseEnter={() => { setIsMouseOver(true) }} data-tooltip='Close' onMouseLeave={() => { setIsMouseOver(false) }} name={name} onClick={onClick} tabIndex={tabable ? '' : '-1'}>
        <img style={{ width: '24px' }} src={isMouseOver ? circleExitWhite : circleExitRed} alt='' />
      </IconButton>
    );
  }
  return (
    <SecondaryButton notsetbackcolorwhenfocus="b" id={id} onMouseEnter={() => { setIsMouseOver(true) }} onMouseLeave={() => { setIsMouseOver(false) }} style={{ padding: '1px 6px 1px 10px' }} name={name} size={size || 'regular'} onClick={onClick} tabIndex={tabable ? '' : '-1'}>
      <span style={{ position: 'relative' }}>{label || 'Close'}</span><img style={{ position: 'relative', width: '14px', top: '-1px', left: '3px' }} src={isMouseOver ? circleExitWhite : circleExitRed} alt='' />
    </SecondaryButton>
  );
}


CloseButton.defaultProps = {
  label: 'Close',
  mode: 'regular',
  tabable : true,
  onlyIcon: false
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  mode: PropTypes.oneOf(['regular', 'light']),
  size: PropTypes.string,
  tabable: PropTypes.bool,
  onlyIcon: PropTypes.bool
};

export default React.memo(CloseButton);